import React from "react";
import Switch from "./Switch";
import classnames from "classnames";

const TwoLabelSwitch = ({ checked, onChange, labelOn, labelOff, size }) => {
  const ref = React.createRef();

  const on = () => {
    if (!checked) {
      ref.current.click();
    }
  };

  const off = () => {
    if (checked) {
      ref.current.click();
    }
  };

  return (
    <div className="tl-switch">
      <Switch checked={checked} onChange={onChange} ref={ref} size={size} />
      <div className="tl-switch__labels">
        <span
          className={classnames("tl-switch__label", { checked: !checked })}
          onClick={off}
        >
          {labelOff}
        </span>{" "}
        |{" "}
        <span
          className={classnames("tl-switch__label", { checked })}
          onClick={on}
        >
          {labelOn}
        </span>
      </div>
    </div>
  );
};

export default TwoLabelSwitch;
